import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { LibraryIcon, ZapIcon, LockIcon, ShieldCheckIcon, BarChart3Icon, SparklesIcon } from 'lucide-react';
const features = [{
  title: 'Task Library',
  desc: 'Create your own habit system.',
  icon: LibraryIcon
}, {
  title: 'Streak Engine',
  desc: 'Track long-term discipline and daily wins.',
  icon: ZapIcon
}, {
  title: 'Distraction Blocking',
  desc: 'Apps stay locked until the task is completed.',
  icon: LockIcon
}, {
  title: 'Daily Accountability',
  desc: 'You must confirm completion before regaining access.',
  icon: ShieldCheckIcon
}, {
  title: 'Progress Visualization',
  desc: 'Weekly streak circle and habit progress indicators.',
  icon: BarChart3Icon
}, {
  title: 'Minimal Friction',
  desc: 'Fast interface built for daily use.',
  icon: SparklesIcon
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function FeaturesSection() {
  return <section className="py-24 bg-ascension-black relative border-t border-white/5" data-id="element-79">
      <div className="max-w-7xl mx-auto px-6" data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-81">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-82">
            The Complete System
          </h2>
          <p className="text-ascension-gray max-w-2xl" data-id="element-83">
            Everything you need to build unbreakable habits, without the bloat.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-84">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-ascension-dark rounded-2xl p-6 border border-white/5 hover:border-ascension-green/30 hover:shadow-[0_0_30px_rgba(68,198,87,0.05)] transition-all duration-300 group" data-id="element-85">
              <div className="w-10 h-10 rounded-lg bg-ascension-black border border-white/10 flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300" data-id="element-86">
                <feature.icon className="text-ascension-green" size={20} data-id="element-87" />
              </div>
              <h3 className="text-lg font-semibold text-white mb-2" data-id="element-88">
                {feature.title}
              </h3>
              <p className="text-ascension-gray text-sm leading-relaxed" data-id="element-89">
                {feature.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}